/**
 * Куда вернуть человека после входа (ingdg_com#193).
 *
 * Отдельным модулем ради теста: `middleware.ts` тянет next-intl, и в
 * юнит-тесте не поднимается — его проверяют чтением исходника. Правило
 * же здесь не косметическое, а защитное, и проверять его глазами нельзя.
 *
 * Значение приходит из адреса (`?callbackUrl=`), то есть от кого угодно.
 * Внешний адрес в этом параметре — готовая открытая переадресация:
 * ссылка с нашим доменом в начале уводила бы на чужой сайт, и именно так
 * устроены фишинговые письма («вы же видели, домен наш»).
 */

/** Адрес по умолчанию: свои дела человека. */
export const KUDA_POSLE_VHODA = '/dashboard';

/**
 * Свой ли это путь.
 *
 * Пускаем только пути от корня: `/dashboard/wallet` — да,
 * `https://chuzhoj.site` и `//chuzhoj.site` — нет. Второй случай
 * коварнее: браузер понимает `//host` как адрес с текущей схемой, то
 * есть это полноценная ссылка наружу, хотя начинается со слэша.
 *
 * Обратный слэш проверяется отдельно: `/\chuzhoj.site` некоторые
 * браузеры разбирают как `//chuzhoj.site`, и правило «начинается с
 * одного слэша» без этого обходится.
 *
 * Тип-предикат, а не просто boolean: иначе проверка не сужает тип для
 * вызывающего, и `putVozvrata` пришлось бы дописывать `!`, то есть
 * заглушать проверку вместо того, чтобы ей пользоваться.
 */
export function svojPut(raw: string | null | undefined): raw is string {
  if (!raw) return false;
  if (!raw.startsWith('/')) return false;
  return !raw.startsWith('//') && !raw.startsWith('/\\');
}

/** Путь возврата: свой из адреса, иначе кабинет. */
export function putVozvrata(raw: string | null | undefined): string {
  return svojPut(raw) ? raw : KUDA_POSLE_VHODA;
}
